import { isInServerPlatform } from '@fabric-app/compat/capabilities/platform';
import { flushSync } from 'react-dom';
import { createRoot } from '../../node_modules/react-dom/client.js';

const reactToHTML = (reactNode) => {
  if (isInServerPlatform() || typeof document === "undefined") {
    return "";
  }
  const div = document.createElement("div");
  const root = createRoot(div);
  flushSync(() => {
    root.render(reactNode);
  });
  const content = div.innerHTML;
  root.unmount();
  return content;
};

export { reactToHTML };
//# sourceMappingURL=reactToHTML.js.map
